import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

import Client from './components/Client';
import Config from './components/ClientConfig';
import DirectPromotion from './components/DirectPromotion';
import DirectPromotionsFilters from './components/DirectPromotionsFilters';
import Visibility from './Visibility';

export default class DirectPromotions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: new Client('none'),
      items: null,
      addNew: false,
      filterData: undefined,
    };
    this.applyFilters = this.applyFilters.bind(this);
    this.toggleAdd = this.toggleAdd.bind(this);
    this.itemUpdated = this.itemUpdated.bind(this);
    this.getData = this.getData.bind(this);

    this.restricted = new Visibility('promotions'); // same scope as Promotions
    this.filtersRef = React.createRef(); 
  }

  componentDidMount() {
    if (this.restricted.scope.visible) this.getData();
  }

  getData() {
    const data = this.state.client.getData(Config.API_URL_PROMOTION_DIRECT, { limit: 20, order: '-dateFrom', with_price_warning: 1 });
    if (data && data.directPromotions) this.setState({ items: data.directPromotions });
  }

  applyFilters(queryData) {
    const q = { limit: 20, order: '-dateFrom', ...(queryData || {}), with_price_warning: 1 };
    const data = this.state.client.getData(Config.API_URL_PROMOTION_DIRECT, q);
    if (data) this.setState({ items: data.directPromotions, filterData: queryData });
  }

  toggleAdd() {
    if (!this.restricted.scope.edit) return;
    this.setState((s) => ({ addNew: !s.addNew }));
    window.scrollTo(0, 0);
  }

  itemUpdated() {
    const queryData = this.state.filterData ? this.state.filterData : {};
    this.setState({ items: null, addNew: false }, () => {
      this.applyFilters(queryData);
      this.getData();
      window.scrollTo(0, 0);
    });
    // reset +/– button in NewsFilters
    if (this.filtersRef?.current) {
      this.filtersRef.current.setState({ addNew: false });    // 👈 switches icon back to +
    }
  }

  render() {
    if (!this.restricted.scope.visible) return <div />;

    let list = null;
    let counter = 0;

    if (this.state.items) {
      counter = this.state.items.length;
      list = this.state.items.map((row) => (
        <DirectPromotion
          key={row.iref}
          item={row}
          itemUpdated={this.itemUpdated}
          allowEdit={this.restricted.scope.edit}
        />
      ));
    }

    return (
      <div style={{ backgroundColor: '#273442', minHeight: '100%' }}>
        <div className="sticky">
          <DirectPromotionsFilters
            ref={this.filtersRef} 
            applyFilters={this.applyFilters}
            toggleAdd={this.toggleAdd}
            itemsCounter={counter}
            allowEdit={this.restricted.scope.edit}
          />
        </div>

        {this.state.addNew ? (
          <DirectPromotion
            key={0}
            item={undefined}
            isNew={true}
            itemUpdated={this.itemUpdated}
            allowEdit={this.restricted.scope.edit}
          />
        ) : null}

        {!this.state.items ? (
          <Box sx={{ p: 2 }}>
            <Skeleton animation="wave" variant="rounded" width={800} height={180} />
            <Skeleton animation="wave" variant="rounded" width={800} height={180} sx={{ mt: 1 }} />
          </Box>
        ) : (
          list
        )}
      </div>
    );
  }
}
